import type { ReactNode } from 'react'

interface PublicRouteProps {
  children: ReactNode
}

// Auth guard disabled — public routes always render.
export function PublicRoute({ children }: PublicRouteProps) {
  return children
}
